import { render } from "./DashboardHome.vue?vue&type=template&id=5a1a207c&scoped=true"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"

import "./DashboardHome.vue?vue&type=style&index=0&id=5a1a207c&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2-stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1a207c"]])

export default __exports__